import { syncCheckoutUser } from '@/utils/checkoutUser'

export default async function (context) {
  const { store, redirect, localePath } = context

  await syncCheckoutUser(context)

  if (!store.state.auth.user?.current_order) {
    return redirect(localePath({ name: 'panier' }))
  }

  if (!store.state.auth.user?.current_order?.shipping_method_range_id) {
    return redirect(localePath({ name: 'panier-livraison' }))
  }

  if (!store.state.auth.user?.is_complete) {
    return redirect(
      localePath({ name: 'compte-informations', query: { checkout: 1 } })
    )
  }
}
